import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../../caremap/CareMapState';
import { useSubscription } from '@meraki-internal/state';
import { NoteForm } from '../generic-notes/NoteForm';
import { CaremapNotesModelFactory } from '../model/CaremapNotesModelFactory';
import { ICaremapNoteResponse } from '../model/NotesClient';
import { EditNoteFormViewModel } from './EditNoteFormViewModel';
import { AlertPresenter } from '../../AlertBinder';
import { useEffect } from 'react';
import { CareMapNoteTracker } from '../model/CareMapNoteTracker';

interface IActiveCaremapNoteEditorPropsV2 {
    noteVM: EditNoteFormViewModel;
    onDeleted: () => void;
    hasPrivateCheckbox?: boolean;
}

export const ActiveCaremapNoteEditor: React.FC<IActiveCaremapNoteEditorPropsV2> = ({ noteVM,  onDeleted, hasPrivateCheckbox = true }) => {
    const tracker = useInstance(CareMapNoteTracker);
    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const notesFactory = useInstance(CaremapNotesModelFactory);
    useSubscription(() => notesFactory);

    const alert = useInstance(AlertPresenter);

    const note = noteVM.getNote();

    useEffect(() => {
        tracker.onNoteViewed(note);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <NoteForm
            note={note}
            isAdd={false}
            canEdit={noteVM.canEdit()}
            noteTarget={note.otherAttributes.noteTarget}
            hasTitle
            hasPrivateCheckbox={hasPrivateCheckbox}
            canDelete={noteVM.canDelete()}
            addAttachmentRequiresInnerhivePlus={noteVM.addAttachmentRequiresInnerhivePlus}
            noteChanged={updatedNote => {
                noteVM.setNote(updatedNote as ICaremapNoteResponse);
            }}
            noteDeleted={async () => {
                try {
                    await noteVM.delete();
                    onDeleted();
                }
                catch (err){
                    alert.showAndLogError(err);
                }
            }}
        />
    );
};
